export default ($i18n) => [
  {
    title: $i18n.t('menu.dashboard'),
    route: 'dashboard',
    icon: 'GridIcon',
  }
]
